var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "airport-search-input" },
    [
      _c("input", {
        ref: "hiddenInput",
        attrs: { type: "hidden", name: _vm.name },
        domProps: { value: _vm.value }
      }),
      _vm._v(" "),
      _c(
        "md-field",
        {
          staticClass: "with-left-icon",
          class: { "md-invalid": !!_vm.inputError }
        },
        [
          !_vm.noLabel ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
          _vm._v(" "),
          _c("label", { staticStyle: { display: "none" } }, [
            _vm._v("disable autofill")
          ]),
          _vm._v(" "),
          !_vm.noIcon
            ? _c("custom-icon", {
                staticClass: "md-prefix",
                attrs: { name: _vm.useIcon }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("md-input", {
            ref: "searchInput",
            attrs: {
              type: "text",
              placeholder: _vm.label + (_vm.required ? " *" : ""),
              disabled: _vm.disabled,
              dusk: "city-search-input",
              autofocus: _vm.autofocus,
              id: "autocomplete-search-input",
              required: _vm.required
            },
            on: {
              blur: function($event) {
                _vm.onBlur($event)
              }
            },
            model: {
              value: _vm.selectedcityName,
              callback: function($$v) {
                _vm.selectedcityName = $$v
              },
              expression: "selectedcityName"
            }
          }),
          _vm._v(" "),
          _c("md-progress-spinner", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.searching,
                expression: "searching"
              }
            ],
            attrs: {
              "md-mode": "indeterminate",
              "md-diameter": 20,
              "md-stroke": 3
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "md-error" }, [
            _vm._v(_vm._s(_vm.inputError ? _vm.inputError[0] : ""))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fbcf316", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fbcf316","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/CityInputComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1fbcf316","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/CityInputComponent.vue
// module chunks = 1 2 3